"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonModel = void 0;
const mobx_1 = require("mobx");
const types_1 = require("@zajno/common/types");
const Validatable_1 = require("./Validatable");
class CommonModel extends Validatable_1.ValidatableModel {
    constructor(v = null, useRefObservable = true) {
        super();
        this._defaultValue = null;
        this.setValue = (value) => {
            this._value = value;
            if (this._validateOnChange) {
                this.validate();
            }
        };
        this.reset = () => {
            this._value = types_1.Getter.getValue(this._defaultValue);
            super.reset();
        };
        this._value = types_1.Getter.getValue(v) || null;
        this._defaultValue = v;
        (0, mobx_1.makeObservable)(this, {
            _value: useRefObservable ? mobx_1.observable.ref : mobx_1.observable,
            setValue: mobx_1.action,
        });
    }
    get valueToValidate() {
        return this._value;
    }
    get value() { return this._value; }
    set value(v) {
        this.setValue(v);
    }
}
exports.CommonModel = CommonModel;
//# sourceMappingURL=CommonModel.js.map